<template>
    <div class="checkout-form">
        <div class="checkout-form_block-delivery">
            <div class="checkout-form_block-title">Способ доставки:</div>
            <dropdown
                    :title="'Нова Пошта - до отделения'"
                    :dropdown-data="delivery"
            />
            <dropdown
                    :title="'Город'"
                    :dropdown-data="city"
            />
            <dropdown
                    :title="'Отделение Нова Пошта'"
                    :dropdown-data="post_office"
            />
        </div>
        <div class="checkout-form_block">
            <div class="checkout-form_block-title">Информация о получателе:</div>
            <input placeholder="Имя">
            <input placeholder="Фамилия">
        </div>
        <div class="checkout-form_block">
            <div class="checkout-form_block-title">Контактная информация:</div>
            <dropdown
                    :title="'E-mail'"
            />
            <input placeholder="E-mail - необязательно">
            <input placeholder="Телефон">
        </div>
        <div class="checkout-form_block">
            <div class="checkout-form_block-title">Комментарий:</div>
            <textarea placeholder="Сообщение - необязательно"></textarea>
        </div>

        <div class="checkout-form_sum">
            <div class="checkout-form_sum-title">Всего:</div>
            <div class="checkout-form_sum-info">
                <span class="price">35 543</span>
                <span class="currency">грн.</span>
            </div>

        </div>
        <div class="checkout-form_button">
            <button class="button-main" @click="sendMessage()">Оформить заказ</button>
        </div>
    </div>
</template>

<script>
    import Dropdown from '../Inputs/Dropdown';
    export default {
        name: "checkoutForm",
        components: { Dropdown },
        data() {
            return {
                delivery: [
                    {
                        name: 'Нова Пошта - до отделения',
                        id: 1
                    },
                    {
                        name: 'Нова Пошта',
                        id: 2
                    },
                    {
                        name: 'Нова',
                        id: 3
                    }
                ],
                city: [
                    {
                        name: 'Киев',
                        id: 1
                    },
                    {
                        name: 'Житомир',
                        id: 2
                    },
                    {
                        name: 'Луцк',
                        id: 3
                    },
                    {
                        name: 'Одесса',
                        id: 4
                    },
                ],
                post_office: [
                    {
                        name: 'Офис 1',
                        id: 4
                    },
                ]
            }
        },
        methods: {
            sendMessage() {}
        }
    };
</script>

<style scoped lang="scss">
    .checkout-form {
        &_block {
            display: flex;
            flex-direction: column;
            &-delivery {
                >div {
                    margin-bottom: 16px;
                }
            }
            &:not(:last-child) {
                margin-bottom: 32px;
            }
            &-title {
                color: #3F4450;
                font-weight: 600;
                font-size: 16px;
                line-height: 21px;
                margin-bottom: 16px;
            }
            input, textarea {
                background-color: #FCFCFC;
                border: 1px solid #D8DDE4;
                border-radius: 5px;
                width: 100%;
                padding: 8px 16px;
                font-size: 14px;
                line-height: 21px;
            }
            input {
                margin-top: 16px;
            }
            textarea {
                font-family: 'Inter Regular';
                height: 104px;
            }
        }
        &_sum {
            display: flex;
            align-items: baseline;
            margin-bottom: 25px;
            &-title {
                font-size: 16px;
                line-height: 25px;
                color: #3F4450;
            }
            &-info {
                display: flex;
                color: #3FB0AB;
                align-items: baseline;
                margin-left: 10px;
                .price {
                    font-size: 22px;
                    line-height: 34px;
                }
                .currency {
                    font-size: 14px;
                    line-height: 21px;
                    margin-left: 5px;
                }
            }
        }
    }
</style>
